module.exports = __webpack_public_path__ + "static/media/img-msg-offers@2x.1edc52f2.png";